var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-popin-modal2",
    {
      class: _vm.popinClassName,
      attrs: {
        id: _vm.popinModal.id,
        "aria-labelledby": _vm.popinModal.label,
        "show-close-button": _vm.popinModal.showCloseButton,
      },
    },
    [
      _c(
        "section",
        {
          attrs: {
            "data-titre-page": _vm.pageTitle,
            "data-type-page": _vm.pageType,
          },
        },
        [
          _c("h3", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("xdsl-line-intention", {
            attrs: {
              "intentions-from-object": _vm.intentions,
              "parent-container-id": _vm.popinModal.id,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }